import React from "react";
import Typography from "Components/CommonComponents/Typography";
import { Navbar, Offcanvas, OffcanvasHeader } from "reactstrap";
import "./navbar.css";
import { UserInfoContext } from "Context/CommonContext";
import { capitalizeWords } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useLocation } from "react-router-dom";
import MultiSearchBar from "utilFunctions/shared/MultiSearchBar";
import MenuIconWhite from "Assets/Icons/MenuIconWhite";
import LeftArrowWhite from "Assets/Icons/LeftArrowWhite";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import { LOPDashboardContext } from "Context/LOPDashboard";
import { MyBranchContext } from "Context/LOPDashboard";
import { SyllabusCompliancesContext } from "Context/SyllabusCompliances";
import NavbarMenu from "Components/NavBar/NavbarMenu";

export const AppBar = (props: any) => {
  const userInfo = React.useContext<any>(UserInfoContext);
  const { setFacultyPerformance } = React.useContext(FacultyPerformanceContext);
  const { setLOPDashboard } = React.useContext(LOPDashboardContext);
  const { setMyBranch } = React.useContext(MyBranchContext);
  const { setSyllabusCompliances } = React.useContext(
    SyllabusCompliancesContext
  );
  const { screen }: any = useWindowSize();
  const location = useLocation();

  const [isSearchOpen, setIsSearchOpen] = React.useState(false);

  const onRequestClose = () => {
    setIsSearchOpen((previous) => !previous);
  };

  const isUrlPatterMatchOrNot = (path: string, pattern: RegExp) => {
    return path.match(pattern);
  };

  const returnPageName = (path: string) => {
    const isScheduleFlow =
      path.includes("/admin/schedule") || // covers both /admin/schedule and /admin/schedule-beta
      isUrlPatterMatchOrNot(location.pathname, /\/attendance\/([^/]+)$/) || // old flow: mark-attendance page
      isUrlPatterMatchOrNot(
        location.pathname,
        /\/schedule-beta\/lecture-details\/([^/]+)$/
      ); // beta flow: lecture details page

    if (!isScheduleFlow) {
      localStorage.setItem("scheduledFilter", "");
      localStorage.setItem("eventType", "");
    }

    if (
      !(
        "/admin/batches".includes(path) ||
        isUrlPatterMatchOrNot(location.pathname, /\/mybatch\/([^/]+)$/)
      )
    ) {
      localStorage.setItem("myBatchsFilter", "");
    }

    if ("/admin/myBranch".includes(path)) {
      return "LOP Dashboard";
    } else if (
      "/admin/myBranch/".includes(path) ||
      isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/)
    ) {
      return "LOP Dashboard";
    } else if (
      "/admin/performance".includes(path) ||
      isUrlPatterMatchOrNot(location.pathname, /\/performance\/(\d+)$/)
    ) {
      return "Student Performance";
    } else if ("/admin/planner".includes(path)) {
      return "Planners";
    } else if ("/admin/schedule".includes(path)) {
      return "Schedule";
    } else if ("/admin/batches".includes(path)) {
      return "Batches";
    } else if ("/admin/mylibrary".includes(path)) {
      return "My Library";
    } else if ("/admin/userManagement".includes(path)) {
      return "User Management";
    } else if ("/admin/syllabusCompliances".includes(path)) {
      return "Syllabus Compliance";
    } else if ("/admin/faculties/regions".includes(path)) {
      return "Faculty Performance";
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/)
    ) {
      return "Batches";
    } else if (
      path.includes("/admin/DRS") ||
      isUrlPatterMatchOrNot(location.pathname, /\/DRS\//)
    ) {
      return "DRS";
    } else {
      return `👋 Hi, ${
        userInfo?.name && typeof userInfo?.name === "string"
          ? userInfo.name.split(" ")[0]
          : ""
      }`;
    }
  };
  React.useEffect(() => {
    const path = location.pathname;

    if (
      !(
        "/admin/faculties/regions".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/branches\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/faculties\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/states\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/branch\/([^/]+)$/)
      )
    ) {
      setFacultyPerformance({});
    }

    if (
      !(
        "/admin/myBranch".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/myBranch\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/performance\/([^/]+)$/)
      )
    ) {
      setLOPDashboard({});
      setMyBranch({});
    }

    if (
      !(
        "/admin/syllabusCompliances".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/mybatch\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/performance\/([^/]+)$/)
      )
    ) {
      setSyllabusCompliances({});
    }
  }, [
    location,
    setFacultyPerformance,
    setLOPDashboard,
    setMyBranch,
    setSyllabusCompliances,
  ]);

  return (
    <Navbar className="navBarMain">
      <Offcanvas
        backdrop={true}
        className="w-100 filterSlider"
        isOpen={isSearchOpen}
        direction="end"
        toggle={onRequestClose}
      >
        <OffcanvasHeader className="filterHeader w-100" />

        <div className="globalSearchFilterDivMB">
          <LeftArrowWhite onClick={onRequestClose} />
          <MultiSearchBar onRequestClose={onRequestClose} />
        </div>
      </Offcanvas>

      {["xxl", "xl", "lg"].includes(screen) ? (
        <>
          <div className="d-flex justify-content-between">
            <MenuIconWhite
              onClick={() => {
                props.toggleSidenav();
                props.setIsMiniSideBar(true);
              }}
            />

            <div className="navbarTitle pl-6 d-flex w-180 gap-4">
              <Typography variant="h6F" color="white">
                {capitalizeWords(returnPageName(location.pathname))}
              </Typography>
            </div>
          </div>

          <div className="d-flex align-items-center gap-3 ">
            <MultiSearchBar />
            <NavbarMenu showMobileSearch={false} />
          </div>
        </>
      ) : (
        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <MenuIconWhite
              onClick={() => {
                props.toggleSidenav();
                props.setIsMiniSideBar(true);
              }}
            />

            <div className="pl-3">
              <Typography variant="h4" color="white">
                {userInfo &&
                  userInfo?.name &&
                  capitalizeWords(returnPageName(location.pathname))}
              </Typography>
            </div>
          </div>

          <NavbarMenu showMobileSearch={true} />
        </div>
      )}
    </Navbar>
  );
};
